(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collections"] && !window.DesignMode) return;
  try {
    
  //swiper top category
  var swiperCT;
  $(window).on('load', function(){
    swiperCT = new Swiper('.swiper-category', {
      freeMode: false,
      loop: true,
      centeredSlides: true,
      slidesPerView: 2,
      spaceBetween: 0,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        769: {
          centeredSlides: false,
          slidesPerView: 4,
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !window.DesignMode) return;
  try {
    
  //swiper top pickup
  //SPサイズのみ
  var swiperPU;
  $(window).on('load resize', function(){
    var isSP = $(".u-pc").css("display") === "none";
    if (isSP) {
      if (swiperPU) {
        return;
      } else {
        swiperPU = new Swiper('.swiper-pickup', {
          freeMode: false,
          slidesPerView: "auto",
          spaceBetween: 0,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
      }
    } else {
      if (swiperPU) {
        swiperPU.destroy();
        swiperPU = undefined;
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !window.DesignMode) return;
  try {
    
  //swiper top main visual
  var swiperMV;
  $(window).on('load', function(){
    swiperMV = new Swiper('.swiper-main', {
      freeMode: false,
      loop: true,
      autoplay: {
        delay: 5000,
      },
      speed: 2000,
      slidesPerView: 1,
      spaceBetween: 0,
    });
    var swiper__slidecount = swiperMV.slides.length - 2;
    if (swiper__slidecount === 1) {
      swiperMV.destroy(true,true);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
